/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:77e6c5185e1e19bd1637, name:aboutOur/index, filebase:index.77e6c5185.js, query:, file:static/js/aboutOur/index.77e6c5185.js */
webpackJsonp([15],{

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(4);

var _global = __webpack_require__(2);

$(function () {
  $(window).resize(function () {
    Affix();
    mousePartner();
  });
  initMap();
  Affix();
  getNews();
  mousePartner();
});
// 吸顶
function Affix() {
  var navTop = $('#navTop').offset().top;
  $("#affixBox").affix({
    offset: {
      top: navTop
    }
  });
}
function mousePartner() {
  var windowWidth = $(window).width();
  if (windowWidth > 768) {
    $('#partner .partner-box').find('li').each(function () {
      if ($(this).index() == 0) {
        // 
      } else {
        $(this).removeClass('active');
      }
    });
    $('#partner .partner-box').find('li').mouseenter(function () {
      $(this).addClass('active').siblings().removeClass('active');
    });
  } else {
    $('#partner .partner-box').find('li').each(function () {
      $(this).addClass('active');
    });
  }
}
// 获取新闻
function getNews() {
  var params = {
    pageNum: 1,
    pageSize: 3
  };
  $.get(_global.baseUrl + '/api/website/activitys', params, function (data) {
    if (data.errorCode == 0) {
      var dataList = data.data.list;
      var html = '';
      for (var i = 0; i < dataList.length; i++) {
        dataList[i].introduction = dataList[i].introduction ? dataList[i].introduction : '';
        html += '<li class="list-group-item">' + '<a href="' + dataList[i].infoUrl + '"target="blank"><div class="clearfix">' + '<div class="left">' + '<img src="' + dataList[i].infoPic + '">' + '</div>' + '<div class="right">' + '<h2 class="tit">' + dataList[i].infoHead + '</h2>' + '<p class="time">' + dataList[i].infoPublishTime + '</p>' + '<p class="content">' + dataList[i].introduction + '</p>' + '</div>' + '</div></a>' + '</li>';
      }
      $('#newsWrapper').html(html);
    }
  });
}

function initMap() {
  var map = new AMap.Map('mapContainer', {
    resizeEnable: true, //是否监控地图容器尺寸变化
    zoom: 18, //初始化地图层级
    center: [113.941509, 22.561167] //初始化地图中心点
  });
  var marker = new AMap.Marker({
    position: new AMap.LngLat(113.941509, 22.561167), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
    title: '车电网'
  });
  var content = ["<div class='mapInfo'>" + "<div class='header'><b>深圳市车电网络技术有限公司</b></div>" + "<div class='content'><p>电话 : 400-808-6233</p>" + "<p>地址 : 深圳市南山区科技园北区宝深路科陆大厦24楼</p></div></div>"];
  var infoWindow = new AMap.InfoWindow({
    isCustom: true, //使用自定义窗体
    content: content.join("<br>"),
    offset: new AMap.Pixel(16, -45)
  });
  AMap.event.addListener(marker, 'mouseover', function () {
    infoWindow.open(map, marker.getPosition());
  });
  AMap.event.addListener(marker, 'mouseout', function () {
    infoWindow.close();
  });
  map.add(marker);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[19]);


// WEBPACK FOOTER //
// static/js/aboutOur/index.77e6c5185.js